
import { useCategoryParams } from '../../hooks/useCategoryParams';
import React from 'react';
import { useCategories } from '../../hooks/useCategories';
import { AccountContext } from "../../context/account/AccountContext";
import styles from './categories.module.css';
import Loading from '../common/Loading';

const CategoriesList: React.FC = () => {
    const { data: accountData } = React.useContext(AccountContext);
    const [params, actions] = useCategoryParams();

    const { data: categories, isLoading, error } = useCategories({
        baseUrl: accountData?.url || '',
        username: accountData?.username || '',
        password: accountData?.password || '',
        action: params.type
    });

    const handleCategoryClick = (categoryId: string) => {
        actions.navigateToCategory(categoryId);
    };

    if (!accountData) {
        return <div className={styles.error}>Ingen kontoinformasjon tilgjengelig</div>;
    }

    if (isLoading) {
        return <Loading />;
    }

    if (error) {
        return <div className={styles.error}>Feil ved lasting av kategorier: {error.message}</div>;
    }

    if (!categories || categories.length === 0) {
        return <div className={styles.empty}>Ingen kategorier funnet</div>;
    }

    return (
        <div className={styles.categoriesContainer}>
            <h2 className={styles.title}>Kategorier ({categories.length})</h2>
            <ul className={styles.categoriesList}>
                {categories.map((category) => {
                    const isSelected = params.categoryId === category.category_id;

                    return (
                        <li
                            key={category.category_id}
                            className={`${styles.categoryItem} ${isSelected ? styles.selected : ''}`}
                            onClick={() => handleCategoryClick(category.category_id)}
                        >
                            <span className={styles.categoryName}>{category.category_name}</span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default CategoriesList;